import Vue from 'vue';
import Router from 'vue-router';
import Works from './views/Works';
import WorkForm from './views/WorkForm';
import Work from './views/Work';
import Actors from './views/Actors';
import ActorForm from './views/ActorForm';
import Actor from './views/Actor';
import Home from './views/Home.vue';
import store from './store.js';

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home,
      meta: {
        title: store.state.siteTitle,
        metaTags: [
          {
            name: 'description',
            content: store.state.siteDescription
          }
        ]
      }
    },{
      path: '/fiches',
      name: 'Works',
      component: Works,
      meta: {
        title: `${store.state.siteTitle} - fiches`,
        metaTags: []
      }
    },{
      path: '/fiches/:workId',
      name: 'Work',
      component: Work,
      meta: {
        title: `${store.state.siteTitle} - fiche`,
        metaTags: []
      }
    },{
      path: '/fiches/:workId/modification',
      name: 'WorkEdit',
      component: WorkForm,
      meta: {
        title: `${store.state.siteTitle} - fiche`,
        metaTags: []
      }
    },{
      path: '/fiches/ajout',
      name: 'WorkAdd',
      component: WorkForm,
      meta: {
        title: `${store.state.siteTitle} - nouvelle fiche`,
        metaTags: []
      }
    },{
      path: '/createurs',
      name: 'Actors',
      component: Actors,
      meta: {
        title: `${store.state.siteTitle} - créateurs`,
        metaTags: []
      }
    },{
      path: '/createurs/:actorId',
      name: 'Actor',
      component: Actor,
      meta: {
        title: `${store.state.siteTitle} - créateur`,
        metaTags: []
      }
    },{
      path: '/createurs/:actorId/modification',
      name: 'ActorEdit',
      component: ActorForm,
      meta: {
        title: `${store.state.siteTitle} - créateur`,
        metaTags: []
      }
    },{
      path: '/createurs/ajout',
      name: 'ActorAdd',
      component: ActorForm,
      meta: {
        title: `${store.state.siteTitle} - nouveau créateur`,
        metaTags: []
      }
    }
  ]
});
